var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ant-design:phone-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.5013 15.4666L52.3458 8.31781C51.841 7.81084 51.2411 7.40859 50.5804 7.13417C49.9197 6.85976 49.2113 6.71858 48.4959 6.71875C47.038 6.71875 45.6674 7.28984 44.6394 8.31781L36.9397 16.0175C36.4327 16.5223 36.0305 17.1222 35.7561 17.7829C35.4816 18.4436 35.3405 19.1519 35.3406 19.8673C35.3406 21.3253 35.9117 22.6959 36.9397 23.7239L42.57 29.3542C41.2521 32.2591 39.4197 34.9018 37.1614 37.1547C34.9088 39.4185 32.2663 41.2575 29.3609 42.5834L23.7306 36.9531C23.2259 36.4462 22.6259 36.0439 21.9653 35.7695C21.3046 35.4951 20.5962 35.3539 19.8808 35.3541C18.4228 35.3541 17.0522 35.9252 16.0242 36.9531L8.31782 44.6461C7.81022 45.1518 7.40763 45.7528 7.1332 46.4147C6.85877 47.0766 6.71792 47.7862 6.71875 48.5027C6.71875 49.9606 7.28985 51.3313 8.31782 52.3592L15.4598 59.5013C17.0992 61.1473 19.3634 62.0813 21.6881 62.0813C22.1786 62.0813 22.6489 62.0409 23.1125 61.9603C32.1694 60.4688 41.1524 55.6514 48.4019 48.4086C55.6447 41.1725 60.4553 32.1963 61.967 23.1125C62.4239 20.3377 61.5034 17.4822 59.5013 15.4666Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2Icon);
export default __webpack_public_path__ + "static/media/phone2-icon.f8247198aeed8df3a372c71db408c79b.svg";
export { ForwardRef as ReactComponent };